import React from 'react';

import type { User } from '@auth0/auth0-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  colors,
  DropdownMenu,
  HStack,
  IconButton,
  Primitive,
} from '@rtkwlf/fenrir-react';
import { faCircle } from '@rtkwlf/pro-solid-svg-icons/faCircle';
import { faUser } from '@rtkwlf/pro-solid-svg-icons/faUser';
import { useTranslation } from 'react-i18next';

export interface UserMenuProps {
  isOnboarding?: boolean;
  user?: User;
  onLogout: () => void;
  children?: React.ReactElement | React.ReactElement[] | null;
}

export const UserMenu: React.FC<UserMenuProps> = ({
  children,
  user,
  onLogout,
  isOnboarding = false,
}) => {
  const { t } = useTranslation();

  return (
    <HStack xAlign="center">
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild>
          <Primitive.div position="relative">
            {isOnboarding && (
              <FontAwesomeIcon
                icon={faCircle}
                color={`rgb(${colors.icon.danger.secondary})`}
                style={{
                  fontSize: '6px',
                  position: 'absolute',
                  right: '4px',
                  top: '4px',
                }}
                title={t('appBar:userMenu.onboardingIcon')}
              />
            )}

            <IconButton aria-label={t('appBar:userMenu.tooltip')}>
              <FontAwesomeIcon icon={faUser} />
            </IconButton>
          </Primitive.div>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="end">
          <DropdownMenu.Header>
            <DropdownMenu.HeaderTitle>
              {user?.email ?? ''}
            </DropdownMenu.HeaderTitle>
          </DropdownMenu.Header>
          <DropdownMenu.Label>
            {t('appBar:userMenu.accountMenu')}
          </DropdownMenu.Label>
          <DropdownMenu.Group>
            {children}

            <DropdownMenu.Item onClick={onLogout}>
              <DropdownMenu.ItemText>
                {t('appBar:userMenu.logOut')}
              </DropdownMenu.ItemText>
            </DropdownMenu.Item>
          </DropdownMenu.Group>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </HStack>
  );
};
